
import { AppButton, AppCard, AppFormRow, AppInput, AppSelect } from '@/components';
import { useStarterPackRewardAdd } from '@/modules/starter/pack/reward/model/add';
import { StarterPackRewardOptions, StarterPackRewardType } from '@/modules/starter/pack/reward/types';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.REWARD.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetchLinkableRewards, create, rewardOptions } = useStarterPackRewardAdd();

        onMounted(async () => {
            await fetchLinkableRewards();
        });

        return { v$, model, create, rewardOptions, StarterPackRewardOptions, StarterPackRewardType };
    }
});
